module.exports = __webpack_public_path__ + "img/bt.da90cdee.png";